import { FC, memo, useContext, useEffect, useMemo } from 'react';
import { BotChatStreamingMessageContainer } from './bot-chat-streaming-message-container';
import { BotChatStreamingMessageAvatar } from './bot-chat-streaming-message-avatar';
import { BotChatStreamingMessageCloud } from './bot-chat-streaming-message-cloud';
import { useTheme } from 'styled-components';
import { BotChatStreamingMessageCloudP } from './bot-chat-streaming-message-cloud-p';
import { BotChatStreamingMessageCloudLoadingAnimation } from './bot-chat-streaming-message-cloud-loading-animation';
import parseMessage from '../../../../utils/parse-message';
import useTypingAnimation from '../../../../hooks/use-type-animation';
import useWaitMessage from '../../../../hooks/use-wait-message';
import { BotChatMessageWrapper } from '../bot-chat-message/bot-chat-message-wrapper';
import scrollToLastMessage from '../../../../utils/scroll-to-last-message';
import { ChatContext } from '../../../../contexts/chat-context';
import { useAppSelector } from '../../../../../common/store';
interface UserChatMessageProps {
  buffer: string;
  onDoneAnimation: () => void;
  agentTyping?: boolean;
}

export const BotChatStreamingMessage: FC<UserChatMessageProps> = ({
  buffer, onDoneAnimation, agentTyping
}) => {
  const theme = useTheme();
  const {clearMessageWait, startMessageWait, message} = useWaitMessage();
  const agentPhoto = useAppSelector(state => state.calls.agentPhotoURL);
  const parsedMessage = useMemo(() => parseMessage(buffer), [buffer]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (typedText) return;
      scrollToLastMessage({ selector: '#streaming-message', block: 'nearest' })
    }, 3000)

    return () => {
      clearTimeout(timeout);
    }
  }, [])

  const { typedText } = useTypingAnimation({
    text: parsedMessage,
    onDoneAnimation,
  });
  const { typedText: typedMessage } = useTypingAnimation({ text: message });

  useEffect(() => {
    if (parsedMessage || agentTyping) return;

    startMessageWait();

    return () => {
      clearMessageWait();
    }
  }, [parsedMessage])

  const avatarSrc = useMemo(() => {
    let src = theme?.themeConfig?.chatMessages?.botMessage?.avatar?.src
    if (agentTyping) {
      src = agentPhoto;
    }
    return src;
  }, [agentPhoto, theme?.themeConfig?.chatMessages?.botMessage?.avatar?.src]);

  return (
    <BotChatMessageWrapper id='streaming-message' className="voa_chat_bot_message">
      <BotChatStreamingMessageContainer className={`voa_avatar_message_container`}>
        <BotChatStreamingMessageAvatar
          src={avatarSrc}
        />

        <BotChatStreamingMessageCloud className="voa_chat_bot_message_cloud_container">
          {typedText ? (
            <BotChatStreamingMessageCloudP
              dangerouslySetInnerHTML={{ __html: typedText }}
              className='voa_chat_bot_message_text'
            />
          ) : (
            <BotChatStreamingMessageCloudP>
              {typedMessage || <BotChatStreamingMessageCloudLoadingAnimation />}
            </BotChatStreamingMessageCloudP>
          )}

        </BotChatStreamingMessageCloud>
      </BotChatStreamingMessageContainer>
    </BotChatMessageWrapper>
  );
};
